import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const codeEthicsList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/unit-ethics/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};

export const codeEthicsAdd = (params) => {
  return _baseClient.post('/unit-ethics/save', { body: params }).then((response) => {
    return response;
  });
};

export const codeEthicsDelete = (params) => {
  return _baseClient.get('/unit-ethics/delete', params);
};

export const codeEthicsDetail = (params) => {
  return _baseClient.get('/unit-ethics/get', params);
};

export const codeEthicsUpdateStatus = (params) => {
  return _baseClient.get('/unit-ethics/update-status', params);
};
